<div class="local-table-toolbar">
  <mat-form-field appearance="outline" class="local-search-field">
    <mat-label>Pesquisar responsável</mat-label>
    <input matInput [(ngModel)]="searchTerm" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
  <button *ngIf="!readonly" type="button" mat-mini-fab class="btn-add" aria-label="Adicionar responsável" (click)="open()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<p class="empty" *ngIf="loading">Carregando responsáveis...</p>
<p class="empty" *ngIf="!loading && !rows.length">Nenhum responsável cadastrado.</p>

<table mat-table [dataSource]="rows" *ngIf="!loading && rows.length" class="related-table">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>NOME</th>
    <td mat-cell *matCellDef="let row">{{ row.responsibleName }}</td>
  </ng-container>
  <ng-container matColumnDef="branch">
    <th mat-header-cell *matHeaderCellDef>FILIAL</th>
    <td mat-cell *matCellDef="let row">{{ branchLabel(row) }}</td>
  </ng-container>
  <ng-container matColumnDef="document">
    <th mat-header-cell *matHeaderCellDef>CPF</th>
    <td mat-cell *matCellDef="let row">{{ row.responsibleCpf || '—' }}</td>
  </ng-container>
  <ng-container matColumnDef="contact">
    <th mat-header-cell *matHeaderCellDef>CONTATO</th>
    <td mat-cell *matCellDef="let row">{{ row.responsibleEmail || row.responsiblePhone || '—' }}</td>
  </ng-container>
  <ng-container matColumnDef="city">
    <th mat-header-cell *matHeaderCellDef>CIDADE/UF</th>
    <td mat-cell *matCellDef="let row">{{ cityLabel(row) }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row" class="row-actions">
      <button type="button" mat-icon-button aria-label="Ver responsável" (click)="open(row, true)">
        <mat-icon class="btn-show">visibility</mat-icon>
      </button>
      <button *ngIf="!readonly" type="button" mat-icon-button aria-label="Editar responsável" (click)="open(row)">
        <mat-icon class="btn-edit">edit</mat-icon>
      </button>
      <button *ngIf="!readonly" type="button" mat-icon-button aria-label="Excluir responsável" (click)="remove(row)">
        <mat-icon class="btn-delete">delete</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
